import * as z from 'zod';

// Types
import { MediaZod } from '@/types/MediaType';
import { CTAZod } from '@/types/CTAType';

const HeaderMenuZod = z.object({
  id: z.number(),
  label: z.string(),
  link: z.string().nullable(),
  highlight: z.boolean(),
  dropdown: z
    .object({
      overview: z.object({
        title: z.string().nullable(),
        description: z.string().nullable(),
      }),
      picture: MediaZod.nullable(),
      linkGroup: z
        .array(
          z.object({
            id: z.number(),
            label: z.string().nullable(),
            links: z.array(CTAZod).nullable(),
          }),
        )
        .nullable(),
    })
    .nullable(),
});

export type HeaderMenuType = z.infer<typeof HeaderMenuZod>;

const HeaderZod = z.object({
  id: z.number(),
  documentId: z.string(),
  menus: z.array(HeaderMenuZod).nullable(),
  cta: CTAZod.nullable(),
});

export type HeaderType = z.infer<typeof HeaderZod>;

export { HeaderZod, HeaderMenuZod };
